import React from 'react';
import { Link } from 'react-router-dom';
import Actions from '../../../App/shared/Actions';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import Linkify from "linkifyjs/react";
import { ISoundtrack } from '../../../../@types/ISoundtrack';
import { checkIfCardCollapsible } from '../../viewsHelper';
import moment from "moment";


interface IProps {
  medium: ISoundtrack;
  eventKey: string;
  activeEventKey: null | string;
  mediumSetter: (medium: ISoundtrack) => void;
  showActions?: boolean;
}

const AudioInfo = (props: IProps) => {
  const onClickActions = (e: any) => e.stopPropagation();
  const { current_user } = useSelector(({ current_user }: any) => ({
    current_user,
  }));
  const containerClass = classnames(
    'audio-info',
    props.eventKey === props.activeEventKey && 'expanded',
    checkIfCardCollapsible(props.medium) && 'cursor'
  );
  
  return (
    <div className={containerClass}>
      <div>
        <p className="title">{props.medium.title}</p>
      </div>
      <div>
        <p className="username text-default">
          <a href={`/${props.medium.user.slug}`}>
            {props.medium.user.username}
          </a>
          {/*<Link to={`/${props.medium.user.slug}`}>
            {props.medium.user.username}
          </Link>*/}
        </p>
      </div>
      {/* <div
        className="description"
        dangerouslySetInnerHTML={{ __html: props.medium.description }}
      /> */}
      {/*<Linkify tagName="pre">{props.medium.description}</Linkify>*/}
      <div onClick={onClickActions}>
        <Actions
          object={props.medium}
          setObject={props.mediumSetter}
          user={current_user}
        />
      </div><br/>
      <span className="date" style={{color: "#666666"}}>
        Release Date: { 
          moment(props.medium.release_date).format("MMMM D, YYYY")
        }
      </span>
      <div className="white-space-overlay" />
    </div>
  );
};
export default AudioInfo;
